import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';
import _ from 'lodash';

export function* getSpotlightSaga() {
    yield* takeEvery("SPOTLIGHT/FETCH", function* (action) {

        try {
            const result = yield call(function (params) {

                var url = _.compact([config.apiEndpoint, 'api/v4/spotlight']).join('/');
                return request.post(url)

                    .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                    .send(params)
                    .then((data) => {
                        return (JSON.parse(data.text))
                    });

            }, action);

            if (result && result.success) {

                yield put({
                    type: 'SPOTLIGHT/SET',
                    spotlight: result
                });

            } else {
                yield put({
                    type: 'SPOTLIGHT/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'SPOTLIGHT/FETCH_FAILED',
                e
            });
        }
    });
}